module.exports = __webpack_public_path__ + "img/footer_logo.edd2deab.png";